module.exports = __webpack_public_path__ + "static/illustration-96d101bbe7530635706784c5481df5be.png";